<template>
  <div class="home-cont" :class="{ 'mobile-class': !isMobile }" v-loading="transferLoading">
    <div class="stake-cont">
      <div class="stake-node-cont">
        <div class="stake-node cursor-pointer" @click.stop="showDropDown=!showDropDown">
          <p v-if="!(currentStakeItem && currentStakeItem.name)" class="text-aa size-28 cursor-pointer">{{ $t('cosmos.cosmos1') }}</p>
          <p v-else class="text-49 size-28 cursor-pointer">{{ currentStakeItem && currentStakeItem.name }}</p>
          <span class="drop-icon">
            <img src="@/assets/image/drop-down.svg" alt="">
          </span>
        </div>
        <div class="stake-dropdown" v-if="showDropDown">
          <div class="stake-list pb-2">
            <template v-if="stakeNodeList.length">
              <div class="stake-node-item" v-for="(item, index) in stakeNodeList" @click="selectItem(item)" :key="item.id">
                {{ item.name }}
              </div>
            </template>
            <div class="text-center pt-2 text-grey" v-else>{{ $t('cosmos.cosmos25') }}</div>
          </div>
        </div>
      </div>
      <p class="d-flex size-26 align-items-center space-between mt-2">
        <span class="text-8f">{{ $t('cosmos.cosmos2') }}</span>
        <span class="text-33">{{ (currentStakeItem && currentStakeItem.apr) || '--' | numFormat }}</span>
      </p>
      <p class="d-flex size-26 align-items-center space-between mt-2">
        <span class="text-8f">{{ $t('cosmos.cosmos3') }}</span>
        <span class="text-33">{{ currentStakeItem && currentStakeItem.tokens || '--' | numFormat }}</span>
      </p>
      <p class="d-flex size-26 align-items-center space-between mt-2">
        <span class="text-8f">{{ $t('cosmos.cosmos4') }}</span>
        <span class="text-33">{{ currentStakeItem && currentStakeItem.commissionRate || '--' }}</span>
      </p>
      <p class="d-flex size-26 align-items-center space-between mt-2">
        <span class="text-8f">{{ $t('cosmos.cosmos27') }}</span>
        <span class="text-33">{{ userStakeInfo && userStakeInfo.unlockTime && `${userStakeInfo.unlockTime}` + $t('cosmos.cosmos28')|| '--' }}</span>
      </p>
      <div class="stake-input-cont mt-4">
        <div class="available-cont size-24 text-8f text-right">
          {{ $t('cosmos.cosmos5') }}：{{ assetBalance || 0  | numFormat }} {{ currentChainInfo && currentChainInfo.symbol || 'ATOM' }}
        </div>
        <div class="input-cont">
          <input @input="stakeInput" v-model="stakeAmount" :placeholder="$t('cosmos.cosmos22')" type="number">
          <span @click="maxClick" class="max-btn">{{ $t('cosmos.cosmos6') }}</span>
          <p v-if="errMsg" class="err-msg text-red mt-1 size-26">{{ errMsg }}</p>
        </div>
      </div>
      <div class="stake-btn" @click="stakeClick">{{ $t('cosmos.cosmos7') }}</div>
    </div>
    <div class="stake-info mt-4" v-loading="stakeInfoLoading">
      <div class="info-title">{{ $t('cosmos.cosmos8') }}</div>
      <div class="stake-item">
        <div class="stake-item-info">
          <span class="font-500 size-28 mr-4">{{ userStakeInfo && userStakeInfo.stakeAmount || 0 | numFormat }} {{ currentChainInfo && currentChainInfo.symbol || 'ATOM' }}</span>
          <!--<span class="text-8f size-24">2021/07/12 16:50</span>-->
        </div>
        <div class="size-26 mt-1 pt-1 d-flex">
          <span class="text-8f">{{ $t('cosmos.cosmos26') }}: </span>
          <span class="text-truncate_one">&nbsp;{{ userStakeInfo && userStakeInfo.unbonding || 0 | numFormat }} {{ currentChainInfo && currentChainInfo.symbol || 'ATOM' }}</span>
        </div>
        <div class="stake-item-option mt-1 d-flex align-items-center space-between">
          <div class="size-26 d-flex">
            <span class="text-8f">{{ $t('cosmos.cosmos9') }}: </span>
            <span class="text-truncate_one">&nbsp;{{ userStakeInfo && userStakeInfo.reward || 0 | numFormatFixSix }} {{ currentChainInfo && currentChainInfo.symbol || 'ATOM' }}</span>
          </div>
          <div class="btn-group">
            <div class="btn btn-active" @click="_sendCosmosTransaction(3)">{{ $t('cosmos.cosmos10') }}</div>
            <div class="btn" @click="withDrawClick">{{ $t('cosmos.cosmos11') }}</div>
          </div>
        </div>
      </div>
    </div>
    <pop-up @maskClick="showPop=false" :show.sync="showPop">
      <div class="exit-cont" @click.stop>
        <p class="size-34 text-center font-500">{{ $t('cosmos.cosmos15') }}</p>
        <p class="text-cont size-30 text-center mt-3">{{ $t('cosmos.cosmos16') }} {{ userStakeInfo && userStakeInfo.stakeAmount || 0 | numFormat }} {{ currentChainInfo && currentChainInfo.symbol || 'ATOM' }}</p>
        <div class="exit-btn">
          <div class="exit-btn-item" @click="showPop=false">{{ $t('cosmos.cosmos17') }}</div>
          <div class="exit-btn-item exit-btn-active" @click="_sendCosmosTransaction(2)">{{ $t('cosmos.cosmos18') }}</div>
        </div>
      </div>
    </pop-up>
  </div>
</template>

<script>
import {divisionDecimals, Minus, Plus, superLong} from "../../api/util";
import PopUp from "../../components/PopUp/PopUp";
import Loading from "../../components/Loading/Loading";
import {
  getCosmosAssetBalance,
  getCosmosClient,
  getCosmosDelegation,
  getUserStakedReward,
  getUserUnbondingDelegation, getValidatorUnlockTime
} from "../../api/cosmos";

export default {
  data() {
    return {
      loading: true,
      address: "",
      showPop: false,
      errMsg: '',
      transferLoading: false,
      lang: '',
      stakeNodeList: [],
      currentStakeItem: null,
      showDropDown: false,
      assetBalance: '',
      userStakeInfo: {},
      stakeAmount: '',
      stakeInfoLoading: false,
      currentEntries: 0,
      maxEntries: 7
    };
  },

  components: {
    PopUp,
    Loading
  },

  watch: {
    "$store.state.lang": {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.lang = val;
        }
      }
    },
    // "$store.state.fromAddress": {
    //   deep: true,
    //   async handler(val) {
    //     console.log(val, 'val')
    //     if (val) {
    //       setTimeout(async () => {
    //         await this.getCosmosNodeList();
    //       }, 100);
    //     }
    //   }
    // },
    stakeAmount: {
      handler(newVal, oldVal) {
        if (newVal) {
          const decimals = this.currentChainInfo.decimals || 6;
          const patrn = new RegExp('^([1-9][\\d]{0,20}|0)(\\.[\\d]{0,' + decimals + '})?$');
          if (patrn.exec(newVal) || newVal === '') {
            this.stakeAmount = newVal;
          } else {
            this.stakeAmount = oldVal;
          }
        }
      },
      deep: true
    },
  },

  async created() {
    setTimeout(async () => {
      await this.getCosmosNodeList();
    }, 300);
  },

  mounted() {
    window.addEventListener('click', () => {
      if (this.showDropDown) this.showDropDown = false;
    }, false);
  },

  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent);
    }
  },

  methods: {
    async getCosmosNodeList() {
      const data = {
        chain: sessionStorage.getItem('network') || this.fromNetwork,
        key: '',
        page: 1,
        size: 10000
      }
      const res = await this.$request({
        url: '/cosmos/stake/validators',
        data
      });
      if (res.code === 1000 && res.data) {
        const tempList = res.data.list.map(item => ({
          ...item,
          // tokens: divisionDecimals(item.tokens || 0, 6)
        }));
        this.stakeNodeList = tempList.sort((a, b) => b.tokens - a.tokens);
        this.currentStakeItem = this.stakeNodeList[0] || {};
      }
      if (!this.currentChainInfo) return;
      await this.getUserStakeInfo();
    },
    async getUserStakeInfo() {
      try {
        if (!this.currentStakeItem) return;
        this.stakeInfoLoading = true;
        const client = await getCosmosClient(this.currentChainInfo.apiUrl);
        const assetBalance = await getCosmosAssetBalance(this.fromAddress, this.currentChainInfo.assetName, client);
        this.assetBalance = divisionDecimals(assetBalance.amount || 0, this.currentChainInfo && this.currentChainInfo.decimals || 6);
        const reward = await getUserStakedReward(this.fromAddress, this.currentStakeItem.operatorAddress, this.currentChainInfo.apiUrl);
        const delegation = await getCosmosDelegation(this.fromAddress, this.currentStakeItem.operatorAddress, client);
        const { reward: pendingReward, currentEntries } = await getUserUnbondingDelegation(this.currentChainInfo.apiUrl, this.fromAddress, this.currentStakeItem.operatorAddress);
        this.currentEntries = currentEntries || 0;
        const { unlockTime, maxEntries } = await getValidatorUnlockTime(this.currentChainInfo.apiUrl);
        this.maxEntries = maxEntries;
        console.log(unlockTime, 'unlockTime');
        console.log(pendingReward, 'pendingReward');
        this.userStakeInfo = {
          stakeAmount: divisionDecimals(delegation && delegation.amount || 0, this.currentChainInfo && this.currentChainInfo.decimals || 6),
          reward: divisionDecimals(reward && reward.amount || 0, Plus(this.currentChainInfo.decimals || 6, 18)),
          unbonding: divisionDecimals(pendingReward, Minus(this.currentChainInfo.decimals || 6, 6)),
          unlockTime: unlockTime
        };
        console.log(this.userStakeInfo, 'userStakeInfo')
        this.stakeInfoLoading = false;
      } catch (e) {
        console.error(e, 'error');
        this.userStakeInfo = {
          stakeAmount: 0,
          reward: 0,
          unbonding: 0,
          unlockTime: 0
        };
        this.stakeInfoLoading = false;
      }
    },
    selectItem(item) {
      this.currentStakeItem = item;
      this.showDropDown = false;
      this.reset();
      this.getUserStakeInfo();
    },
    async _sendCosmosTransaction(type) {
      try {
        if (this.wrongNetwork || type == 3 && this.userStakeInfo.reward == 0) return false;
        // if (type == 2)
        console.log(type, this.currentEntries, 'currentEntries')
        const data = {
          type,
          address: this.fromAddress,
          validatorAddress: this.currentStakeItem.operatorAddress,
          amount: type == 1 ? this.stakeAmount : type == 2 ? this.userStakeInfo.stakeAmount : '0'
        }
        console.log(data, '==transferData==')
        const walletType = localStorage.getItem("wallet");
        const res = await window[walletType].cosmos.sendTransaction(data);
        console.log(res, 'crocncl1ax8vwqly42dxu9l5ucfqg6ex9krpzy5y2zylmv')
        if (res) {
          this.$message({
            type: 'success',
            message: this.$t('cosmos.cosmos19'),
            duration: 2000
          });
          this.reset();
          await this.getUserStakeInfo();
        }
      } catch (e) {
        this.$message({
          type: 'warning',
          message: e.message || e,
          duration: 2000
        });
        this.reset();
      }
    },
    async stakeClick() {
      if (!this.stakeAmount || this.errMsg) return;
      await this._sendCosmosTransaction(1);
    },
    withDrawClick() {
      if (!this.userStakeInfo.stakeAmount || this.userStakeInfo.stakeAmount == 0) return;
      if (this.currentEntries == this.maxEntries) {
        this.$message.warning(this.$t('cosmos.cosmos29'));
        return;
      }
      this.showPop = true;
    },
    stakeInput() {
      if (Minus(this.stakeAmount, this.assetBalance) > 0) {
        this.errMsg = `Insufficient ${this.currentChainInfo.symbol} balance`;
      } else {
        this.errMsg = '';
      }
    },
    maxClick() {
      if (!this.assetBalance || !Number(this.assetBalance)) return;
      this.stakeAmount = this.assetBalance;
    },
    reset() {
      this.showPop = false;
      this.errMsg = "";
      this.stakeAmount = "";
    },
    superLong(str, len = 5) {
      return superLong(str, len)
    },
    numberFormat(val, float, returnBoo = false) {
      if (!Number(val)) {
        if (returnBoo) {
          return '';
        }
        return '0';
      }
      const numberVal = val.toString();
      const n = float || 6;
      if (n <= 0) return numberVal;
      return numberVal.replace(/(\.\d+?)0*$/, '$1');
    }
  },
};
</script>
<style lang="less">
.home-cont {
  height: 100%;
  padding: 40px;
  background-color: #F4F7F8;
  .stake-cont {
    background: #FFFFFF;
    box-shadow: 0px -2px 4px 0px rgba(16,24,40,0.06), 0px 2px 6px 0px rgba(16,24,40,0.1);
    border-radius: 24px 24px 24px 24px;
    padding: 68px 40px 80px 40px;
    .stake-node-cont {
      position: relative;
      .stake-node {
        padding: 24px 26px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 16px;
        border: 1px solid #E9EBF3;
        margin-bottom: 36px;
        .drop-icon {
          height: 10px;
          width: 20px;
          img {
            height: 100%;
            width: 100%;
            vertical-align: 10px;
          }
        }
      }
      .stake-dropdown {
        //width: 590px;
        position: absolute;
        z-index: 66;
        min-height: 40px;
        max-height: 490px;
        border: 1px solid #e4e7ed;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        margin: 5px 0;
        top: 90px;
        left: 0;
        right: 0;
        border-radius: 12px;
        overflow: auto;
        &::-webkit-scrollbar {
          background-color: rgba(27,27,27,.4);
          border-radius: 20px;
          width: 6px; // y轴滚动条宽度
          height: 6px; // x轴滚动条高度
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 20px; // 滚动条的圆角
          background: #6EB6A9; // 滚动条的背景颜色
        }

        &::-webkit-scrollbar-track {
          border-radius: 20px; // 滚动条的背景区域的圆角
          background: #fff; // 滚动条的背景颜色
        }
        .stake-node-item {
          height: 30px;
          line-height: 30px;
          font-size: 26px;
          padding: 20px;
          cursor: pointer;
          &:hover {
            background-color: #f2f6fc;
            color: #49C7B5;
          }
        }
      }
    }
    .stake-input-cont {
      .available-cont {

      }
      .input-cont {
        position: relative;
        margin-top: 12px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 2px solid #E9EBF3;
        border-radius: 16px;
        input {
          flex: 1;
          outline: none;
          height: 40px;
          border: none;
          font-size: 32px;
          color: #333333;
          font-weight: 500;
          background-color: transparent;
          &::placeholder {
            color: #ABB1BA;
          }
        }
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
          margin: 0;
        }
        .max-btn {
          padding: 14px;
          background-color: #E7F5F4;
          color: #49C7B5;
          font-size: 24px;
          border-radius: 12px;
          cursor: pointer;
        }
        .err-msg {
          position: absolute;
          bottom: -35px;
          left: 5px;
        }
      }
    }
    .stake-btn {
      height: 88px;
      background: #49C7B5;
      line-height: 88px;
      text-align: center;
      color: #FFFFFF;
      margin-top: 50px;
      border-radius: 16px 16px 16px 16px;
      font-size: 30px;
      cursor: pointer;
    }
  }
  .stake-info {
    overflow: hidden;
    background-color: #FFFFFF;
    box-shadow: 0 2px 6px 0 rgba(16,24,40,0.1);
    border-radius: 24px;
    padding: 60px 40px;
    .info-title {
      font-size: 32px;
      color: #333333;
      font-weight: 500;
    }
    .stake-item {
      padding: 28px 0;
      border-bottom: 1px solid #E9EBF3;
      .stake-item-info {

      }
      .stake-item-option {
        p {
          //width: 180px;
        }
        .btn-group {
          display: flex;
          align-items: center;
          .btn {
            cursor: pointer;
            background-color: #E7F5F4;
            color: #49C7B5;
            padding: 16px;
            border-radius: 12px;
            &:first-child {
              margin-right: 16px;
            }
            &.btn-active {
              background-color: #49C7B5;
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}
.exit-cont {
  padding: 60px 40px;
  background-color: #FFFFFF;
  border-radius: 24px;
  width: 590px;
  .exit-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 48px;
    .exit-btn-item {
      cursor: pointer;
      width: 280px;
      height: 88px;
      font-size: 30px;
      line-height: 88px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 16px 16px 16px 16px;
      border: 2px solid #E9EBF3;
      color: #333333;
      &.exit-btn-active {
        background-color: #49C7B5;
        color: #FFFFFF;
      }
    }
  }
}
.text-8f {
  color: #8F95A8;
}
.text-33 {
  color: #333333;
}
.text-49 {
  color: #49C7B5;
}
.mr-4 {
  margin-right: 40px;
}
.text-cont {
  line-height: 50px;
}
@media screen and (min-width: 1000px) {
  .mobile-class {
    height: 1350px;
  }
}
</style>
